import React from 'react'
import './ButtonSpinner.scss'

const ButtonSpinner = ({size = 0.75, color='#ffffff'}) => {
  return (
    <div className='ButtonSpinner' style={{width: `${size}rem`, height: `${size}rem`, borderColor: color}}/>
  )
}

export default ButtonSpinner